module.exports = __webpack_public_path__ + "static/media/7x7BadOptimized.29491e94.jp2";